/**
 * Auth related mehtods like sign up, sign in and sso
 */

import axios, { baseRequestConfig } from './base';

// login using username and password
export function login(params) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_login_email',
        values: {
          email: params.username,
          'g-recaptcha-response': params['g-recaptcha-response'],
        },
      },
    },
  });
}


// get facebook sso details
export function facebookSSOInformation() {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'system_get_facebook_app_info',
      },
    },
  });
}
// get facebook sso details
export function fetchGoogleSiteKey() {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'system_get_recaptcha_key',
      },
    },
  });
}


// login/register using facebook sso
export function facebookSSOLogin(token) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_sso_check_login',
        values: {
          short_access_token: token,
        },
      },
    },
  });
}


export function googleSSOLogin(token) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_sso_check_login',
        values: {
          google_access_token: token,
        },
      },
    },
  });
}

// login/register using facebook sso
export function emailLogin(token) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_sso_check_login',
        values: {
          email_token: token,
        },
      },
    },
  });
}

export function userAnonymousLogin(value) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_sso_check_login',
        values: {
          hash: value,
        },
      },
    },
  });
}

// user token check
export function userTokenCheck(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_check_token',
      },
    },
  });
}

export function getUserId(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_get_userid_from_usertoken',
        values: {
          user_token: userToken,
        },
      },
    },
  });
}

export function getSystemText(userToken, textKey) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'system_get_text',
        values: {
          text_key: textKey,
        },
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/auth.js